import { Expose } from "class-transformer";
import type { SenderTypeEnum } from "../enums/sender-type.enum";

export interface IConversationMessageDto {
  id: number;
  sessionId: string;
  senderType: SenderTypeEnum;
  message: string;
}

export class ConversationMessageDto implements IConversationMessageDto {
  @Expose()
  id!: number;

  @Expose()
  sessionId!: string;

  @Expose()
  senderType!: SenderTypeEnum;

  @Expose()
  message!: string;
}
